// Native emits an event object when Dynamic Type, wrapping, or the draft
// changes. Never feed that object (or a non-finite measurement) into Yoga.
export function getComposerContentHeight(measurement, minHeight = 46, maxHeight = 240) {
  const height = typeof measurement === 'number'
    ? measurement : measurement?.nativeEvent?.contentSize?.height;
  if (typeof height !== 'number' || !Number.isFinite(height) || height < 0) return null;
  return Math.min(Math.max(minHeight, Math.ceil(height)), maxHeight);
}

export function resizeComposerTextarea(textarea, minHeight = 46, maxHeight = 240) {
  textarea.style.height = `${minHeight}px`;
  // A wrapped placeholder is guidance, not a draft that needs extra space.
  const contentHeight = textarea.value ? textarea.scrollHeight : minHeight;
  const height = Math.min(Math.max(minHeight, contentHeight), maxHeight);
  textarea.style.height = `${height}px`;
  textarea.style.overflowY = contentHeight > maxHeight ? 'auto' : 'hidden';
  return height;
}

export function observeTextareaWidth(textarea, onWidthChange) {
  let previousWidth = null;
  const measure = () => {
    const width = textarea.getBoundingClientRect().width;
    if (width <= 0 || (previousWidth !== null && Math.abs(width - previousWidth) < 0.5)) return;
    previousWidth = width;
    onWidthChange();
  };
  measure();
  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(measure);
    observer.observe(textarea);
    return () => observer.disconnect();
  }
  window.addEventListener('resize', measure);
  return () => window.removeEventListener('resize', measure);
}
